const colors = {
  brown: {
    100: '#F2EEE4',
    300: '#E7DFCD',
    500: '#D9CCB2',
    700: '#988F7D',
    900: '#28160A',
  },
  gray: {
    300: '#E6E1DA',
    500: '#777',
  },
  accent: {
    500: '#FF335F',
  },
  red: {
    500: '#E02951',
    700: '#CC1E44',
  },
  text: {
    primary: '#28160A',
    secondary: '#988F7D',
    dark: '#302E2C',
  },
  button: {
    background: '#28160A',
    backgroundHover: '#433e3a',
    backgroundActive: '#000',
  },
  white: 'white',
  black: 'black',
  transparent: 'transparent',
};

export default colors;
